import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { action, observable } from 'mobx'

export type SpouseProps = ModelProps<Spouse>

export class Spouse extends Model<Spouse> {
  id = Id.none

  @observable accessor firstName: string | null = null
  @observable accessor middleInitial: string | null = null
  @observable accessor lastName: string | null = null
  @observable accessor tin: string | null = null
  @observable accessor dob: Date | null = null
  @observable accessor phoneNumber: string | null = null
  @observable accessor emailAddress: string | null = null
  @observable accessor occupation: string | null = null

  @action.bound
  clear(): void {
    this.id = Id.none
    this.firstName = null
    this.middleInitial = null
    this.lastName = null
    this.tin = null
    this.dob = null
    this.phoneNumber = null
    this.emailAddress = null
    this.occupation = null
  }

  toProps(): SpouseProps {
    return {
      id: this.id,
      firstName: this.firstName,
      middleInitial: this.middleInitial,
      lastName: this.lastName,
      tin: this.tin,
      dob: this.dob,
      phoneNumber: this.phoneNumber,
      emailAddress: this.emailAddress,
      occupation: this.occupation,
    }
  }
}
